import React, { useEffect, useContext } from 'react';
import { Link, navigate } from 'gatsby';
import { useCookies } from 'react-cookie';
import renderLink from '~/utils/render-link';
import FooterCTA from '~/components/FooterCTA';
import NewsletterSubscribe from '~/components/NewsletterSubscribe';
import Logo from '~/images/logo.svg';
import logoWhite from '~/images/logo-white.svg';
import SocialIconAlt from '~/components/SocialIconAlt';
import camera from '~/images/camera.svg';
import TransContext from '~/contexts/TransContext';
import footerNavs from '~/data/footer-navs';

function Footer({ footerColor = 'white', footerCTAContent, hideFooterCta, hideSecondaryFooterCta }) {
  const isWhiteFooter = footerColor === 'white';
  const trans = useContext(TransContext);
  const localeFooter = trans?.lang?.length > 0 ? footerNavs[trans?.lang] : footerNavs['default'];

  const [cookies, setCookie] = useCookies(['selected_lang']);

  const navigateToLang = (lang = 'en') => {

    let path = `/${lang}/`;
    if (lang === 'en') {
      path  = '/'
    }

    setCookie(`selected_lang`, lang);
    navigate(path);
  }


  return (
    <div className={isWhiteFooter ? 'text-black' : 'text-white bg-black'}>
      {!hideFooterCta && <FooterCTA {...footerCTAContent} />}
      <footer className={isWhiteFooter ? 'text-black' : 'text-white bg-black'}>
        <div className={`container divide-y ${isWhiteFooter ? 'divide-light-grey' : 'divide-grey'} `}>
          {hideFooterCta && !hideSecondaryFooterCta && <div></div>}{' '}
          {/* Looks dumb I know... But the blank div is pushing a border onto the section below due to the parent 'divide-y-2' so 🤷‍♂️ */}
          {!hideSecondaryFooterCta && (
            <section className={`flex justify-center my-12 mt-8 ${hideFooterCta && 'pt-12'}`}>
              <div className="flex flex-col flex-wrap items-center justify-center md:flex-row md:space-x-6">
                <img src={camera} alt="footer cam" width={35} className="mb-4 md:mb-0" />
                <div className="mb-2 font-bold text-18px md:mb-0">{trans?.content?.secondaryFooterCTAHeading}</div>
                <div className={`mt-3 md:mt-0`}>
                  <Link
                    to={renderLink(trans.content.secondaryFooterCTAButton[0].button.cached_url)}
                    className={`c-btn c-btn--outline c-btn--shorter ${
                      isWhiteFooter ? 'c-btn--outline--black' : 'c-btn--outline--white'
                    }`}
                  >
                    {trans.content.secondaryFooterCTAButton[0].title}
                  </Link>
                </div>
              </div>
            </section>
          )}
          <section className="py-16">
            <Link to={renderLink('/')} className="block">
              {isWhiteFooter ? (
                <img src={Logo} alt="boom logo" className="w-full md:max-w-[200px] max-w-[150px]" />
              ) : (
                <img src={logoWhite} alt="boom logo" className="w-full md:max-w-[200px] max-w-[150px]" />
              )}
            </Link>

            <div className="pt-16">
              <nav className="flex flex-wrap justify-start -mb-8 -ml-12">
                {localeFooter?.map(({ name, items, socialIcons = false }, i) => (
                  <div key={`col${name + i}`} className="flex-none w-1/2 pl-12 mb-8 sm:w-1/4 lg:flex-auto lg:w-auto">
                    <div className="mb-4 font-bold uppercase text-16px" dangerouslySetInnerHTML={{ __html: name }} />
                    <div className="text-15px">
                      {items.map((item) => (
                        <div key={name + item.title}>
                          <Link
                            to={renderLink(item.url)}
                            activeClassName="text-blue"
                            className="inline-block mb-2 transition-colors duration-200 hover:text-blue"
                            dangerouslySetInnerHTML={{ __html: item.title }}
                          />
                        </div>
                      ))}
                    </div>
                    {socialIcons && (
                      <div className="">
                        <div className="flex -mt-2 -ml-3">
                          {[
                            {
                              type: 'facebook',
                              url: 'https://www.facebook.com/boomimagestudio/'
                            },
                            {
                              type: 'youtube' ,
                              url: 'https://www.youtube.com/channel/UC3LCz511UOJoVRIdEx4rO-Q'
                            },
                            {
                              type: 'linkedin' ,
                              url: 'https://www.linkedin.com/company/boom-imagestudio/'
                            },
                            {
                              type: 'instagram' ,
                              url: 'https://www.instagram.com/boomimagestudio/'
                            }].map(
                            (item, i) => (
                              <div key={`${i}`}>
                                <SocialIconAlt url={item.url} type={item.type} invert={`${isWhiteFooter ? false : true}`} />
                              </div>
                            )
                          )}
                        </div>
                        <div className="mt-8">
                          <select
                            onChange={({ target: { value } }) => navigateToLang(value)}
                            defaultValue={(trans.lang !== 'default' ? trans.lang : '')}
                            className={`h-12 px-4 w-full text-16px font-bold font-heading border text-black`}
                          >
                            <option value="en">English</option>
                            <option value="it">Italiano</option>
                            <option value="fr">Français</option>
                            <option value="es">Español</option>
                          </select>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </nav>
            </div>
          </section>
          <section className="py-8">
            <NewsletterSubscribe />
          </section>
          <section className="py-12">
            <nav className="flex flex-wrap pb-8 -ml-8 md:flex-nowrap">
              {trans?.content?.legalLinks?.map((item, i) => (
                <div key={`legal${i}`} className="w-full pl-8 mb-2 font-medium text-15px md:w-auto md:mb-0">
                  <Link
                    to={renderLink(item.Link.url)}
                    className="inline-block font-semibold transition-colors duration-200 hover:text-blue"
                    dangerouslySetInnerHTML={{ __html: item?.Title }}
                  />
                </div>
              ))}
            </nav>
            <div className={`max-w-4xl pb-8 text-13px `}>
              <div className={`mb-1 font-semibold ${isWhiteFooter ? 'text-footer-grey' : 'text-white'}`}>
                {trans?.content?.companyRegistration}
              </div>
              <div
                className={`${isWhiteFooter ? 'text-footer-grey' : 'text-white'}`}
                dangerouslySetInnerHTML={{ __html: trans?.content?.footerLegal }}
              />
            </div>
            <div className="font-medium text-14px">
              © {new Date().getFullYear()}. BOOM. {trans?.content?.rightsReserved}
            </div>
          </section>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
